/*
 * @Description: 计算字段有关
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

import { reactive, toRefs } from 'vue';
import { Message } from '@arco-design/web-vue';
// import { fieldType } from '@/utils/const';
import { formulaFieldService } from '@/api/';
import i18n from '@/locales/index';
export default function useFormulaSetting() {
  const data = reactive({
    enableFieldsList: {}, //已经启用的字段
    findCountFieldsList: [], //本页面所有的计算字段key合集
    countFieldsResult: [], //计算字段计算出的结果
    disableFields: [9, 18, 21, 25, 26, 27], //禁用的字段(把富文本，子表单，引用字段，日期范围，附件过滤  查找关联多选)
    getComputeFields: [] //获取计算公式中的字段
  });

  // 获取字段列表
  const getEnableFields = async (param, fieldKey = null) => {
    data.enableFieldsList = {};
    try {
      const json = await formulaFieldService.getEntitySettings(param);
      if (!json.error) {
        let result = json?.result?.[param?.entities?.[0]]?.settings || [];
        result = result
          ?.filter((i) => i.fieldKey != fieldKey && !data.disableFields.includes(i.fieldType))
          ?.map((item) => {
            return {
              ...item,
              entityId: param?.entities?.[0]
            };
          });
        const fieldItem = {
          entityType: param?.entities?.[0],
          child: result
        };
        fieldItem.originalFieldList = result?.length > 0 ? JSON.parse(JSON.stringify(fieldItem)) : ''; //用一个变量保存原始数据用来搜索
        data.enableFieldsList = fieldItem;
      }

      return data;
    } catch (e) {
      return data;
    }
  };
  // 获取公式中的字段信息
  const getComputeSettings = async (params) => {
    data.getComputeFields = [];
    try {
      const json = await formulaFieldService.getComputeSettings(params);
      if (!json.error) {
        data.getComputeFields = json.result;
      }
      return data;
    } catch (e) {
      return data;
    }
  };
  // 替换公式当中的函数 （后端需要在函数中拼接 #）
  const versionFun = (str, funObj) => {
    let regexPattern = '('; //生成匹配字段名的正则
    for (const obj of funObj) {
      regexPattern += `\\s*${obj.name}\\s*|`;
    }
    //2025年06月09日16:15:15弱网兼容funObj为空regexPattern值为"("时去掉括号导致调用RegExp报错，所以当长度>1时才进行字段截取 zl
    if (regexPattern?.length > 1) {
      regexPattern = regexPattern.slice(0, -1); // 去掉最后一个'|'
    }
    regexPattern += ')';
    const regex = new RegExp(regexPattern, 'g');
    // console.log('regex---',regex);
    // const regex = /(\s*AVG\s*|\s*MIN\s*|\s*MAX\s*|\s*SUM\s*|\s*VALUE\s*|\s*MID\s*|\s*CONCATENATE\s*|\s*LEFT\s*|\s*RIGHT\s*|\s*DATEDIF\s*|\s*IFS\s*|\s*AND\s*|\s*OR\s*|\s*IF\s*|\s*DATE\s*|\s*TODAY\s*)/g;
    return str.replace(regex, (matchedFieldName) => {
      const cleanedFieldName = matchedFieldName.trim();
      const matchedObject = funObj.find((obj) => obj.name === cleanedFieldName);
      if (matchedObject) {
        return '#' + cleanedFieldName;
      } else {
        return matchedFieldName; // 如果没有找到匹配的对象，则原样返回字段名
      }
    });
  };
  // 公式校验 把字段名替换成需要的值
  const containsVariables = (str, funObj, type) => {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(str, 'text/html');

    // 获取所有类名为"selField"的span元素
    const selFieldSpans = htmlDoc.querySelectorAll('.selField');
    // eslint-disable-next-line no-debugger
    // debugger;
    selFieldSpans.forEach((span) => {
      // 获取父节点以及data-value属性值
      const parent = span.parentNode;
      const dataValue = type == 1 ? '#field_' + span.dataset.id : type == 2 ? span.dataset.value : '#' + span.dataset.value;
      // 替换整个span标签为data-value属性值
      parent.replaceChild(htmlDoc.createTextNode(dataValue), span);
    });

    if (type == 1 || type == 3) {
      const innerHTML = htmlDoc.body.innerHTML;
      // 获取处理后的innerHTML
      return versionFun(innerHTML, funObj);
    }
    if (type == 2) return htmlDoc.body.innerHTML;
  };
  //   获取后端需要的字段id和entityid合集
  const getParemSettingList = (str) => {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(str, 'text/html');
    // 获取所有类名为"selField"的span元素
    const selFieldSpans = htmlDoc.querySelectorAll('.selField');
    const paremSettingList = [];
    selFieldSpans?.forEach((span) => {
      if (span.dataset?.entityid && span.dataset?.value) {
        paremSettingList.push({
          fieldType: span.dataset.type,
          entityId: span.dataset.entityid,
          fieldKey: span.dataset.value
        });
      }
    });
    return paremSettingList;
  };
  //   获取页面中的计算字段
  const findComputeing = async (entity, viewId, entityType) => {
    const entityList = [entity];
    // customForm?.forEach((item) => {
    //   if (item?.modules) {
    //     item?.modules?.forEach((list) => {
    //       if (list?.type == 30) {
    //         entityList.push(Number(list.businessData));
    //       }
    //     });
    //   }
    // });
    const params = {
      entityId: entityList,
      id: viewId,
      type: entityType
    };
    try {
      const json = await formulaFieldService.findComputing(params);
      data.findCountFieldsList = json?.result || [];
      return data;
    } catch (e) {
      data.findCountFieldsList = [];
      return data;
    }
  };
  //   公式校验正确性
  const getVerifyFomula = async (params) => {
    const funObj = [];
    params.originalFieldListFuns?.forEach((item) => {
      funObj.push(...item.functionList);
    });
    let formula = containsVariables(params.computeFormulaUi, funObj, 3);
    formula = formula.replace(/<br\s*\/?>/gi, '');
    return new Promise((resolve, reject) => {
      formulaFieldService
        .checkFormula({ formula: formula, entityId: params.entityId, type: params.computeType, dataType: params.dataType, paremSettingList: getParemSettingList(params.computeFormulaUi), tempSettingIds: params?.tempSettingIds || '', tempDisableSettingIds: params?.tempDisableSettingIds || '' })
        .then((res) => {
          if (res.error && res.error?.msg) {
            Message.error(res.error?.msg || i18n.global.t('操作失败'));
            return;
          }
          if (!res?.result?.success) {
            //false 校验不通过
            Message.warning(res?.result?.tips || '公式异常，请确认');
          } else {
            Message.success('表达式语法正确');
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
    // try {
    //   const json = await formulaFieldService.checkFormula({ formula: formula, entityId: params.entityId, type: params.computeType, dataType: params.dataType });
    //   if (json.error && json.error?.msg) {
    //     Message.error(json.error?.msg || i18n.global.t('操作失败'));
    //     return false;
    //   }
    //   if (!json.success) {
    //     //false 校验不通过
    //     Message.warning(json?.result?.tips || '公式异常，请确认');
    //     return false
    //   }
    //   Message.success('表达式语法正确');
    //   return true
    // } catch (e) {
    //     return false
    // //   console.log(e);
    // }
  };
  return {
    getComputeSettings,
    getEnableFields,
    containsVariables,
    getParemSettingList,
    findComputeing,
    getVerifyFomula,
    ...toRefs(data)
  };
}
